import {
  Box,
  Paper,
  Grid,
  Button,
  TextField,
  Typography,
  InputLabel,
  FormHelperText,
  Container,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import React from "react";
import Header from "../../layout/Header";
import banner1 from "../../assets/Banner/WebBanner/b2.png";
import HeroSection from "../HeroSection";

// import banner1 from "../../assets/Banner/WebBanner/b2.png";

const JobDetails = () => {
  console.log("JobDetails");

  return (
    <>
      {/* <HeroSection
        bannerImage={banner1}
        heading="Careers at Across Assist"
        description="Be part of a team that’s passionate about innovation and making a difference. At Across Assist, your ideas matter and your growth is our priority. Discover opportunities to learn, lead, and shape the future of protection. Join us—let’s build something meaningful together."
        // image={logo}
        gradientBg="linear-gradient(268.53deg, #1363DF 28.18%, #000000 124.21%)"
        gradientOpacity={0.9}
      /> */}
      <Box sx={{ px: 0, py: 0 }}>
        <Container maxWidth="lg">
          <Box
            mb={1}
            align="center"
            display="flex"
            alignContent="center"
            justifyContent="space-between"
          ></Box>

          {/* <Grid
                        mb={4}
                        container
                        spacing={2}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                            p: { xs: 2, md: 0 },
                            mb: { xs: 1, md: 4 },
                        }}
                    >
                        <Card sx={{ p: 2 }} elevation={2}>
                            <Grid item xs={12} md={6}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <InfoItem
                                            icon={WorkIcon}
                                            label="Department"
                                            value="Technology"
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <InfoItem
                                            icon={EmojiPeopleIcon}
                                            label="Experience"
                                            value="3-5 years"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid mt={1} item xs={12} md={6}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <InfoItem
                                            icon={LocationOnIcon}
                                            label="Joining"
                                            value="Immediate"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InfoItem
                                            icon={CalendarMonthIcon}
                                            label="Salary"
                                            value="Market standards"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Grid mt={1} container spacing={2}>
                                    <Grid item xs={12}>
                                        <InfoItem
                                            icon={LocationOnIcon}
                                            label="No. of positions"
                                            value="2"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InfoItem
                                            icon={CalendarMonthIcon}
                                            label="Work Location"
                                            value="Gurgaon"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Grid mt={1} container spacing={2}>
                                    <Grid item xs={12}>
                                        <InfoItem
                                            icon={LocationOnIcon}
                                            label="Working Hours"
                                            value="10:00am – 06:30pm"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InfoItem
                                            icon={CalendarMonthIcon}
                                            label="Working Days"
                                            value="5 Days"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid> */}
        </Container>

        <Box sx={{ backgroundColor: "#f9f4f2" }}>
          <Container maxWidth="lg" sx={[styles.ParentContainer]}>
            <Box sx={styles.DetailsContainer}>
              <Grid container spacing={4}>
                {/* Roles and Responsibilities Section */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Box align="left" mt={0}>
                      <Typography variant="h4">
                        Roles and Responsibilities
                      </Typography>
                    </Box>

                    <ul style={{ marginTop: -2 }}>
                      <li style={styles.DescriptionTxt}>
                        Building and shipping robust apps to Android/iOS using a
                        single codebase.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Writing readable and clear code using Dart, extensively
                        documented.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Sharing feedback and brainstorming ideas with the team.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Understanding basic design for user-friendly apps.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Staying up to date with the latest tech.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Coordinating with other team members during development.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Identifying/resolving defects, providing support &
                        updates.
                      </li>
                    </ul>
                  </Box>
                </Grid>

                {/* Skills Section */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Box align="left">
                      <Typography variant="h4">Skills</Typography>
                    </Box>
                    <ul style={{ marginTop: -2 }}>
                      <li style={styles.DescriptionTxt}>
                        Bachelor's in CS, IT, or similar field.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        OOP concepts & design patterns.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Mobile app development (iOS/Android).
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Experience with Dart, Flutter, React Native.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Understanding Agile/Scrum.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Readable, maintainable code practices.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Version control & IDEs familiarity.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Experience with Java, Kotlin, Swift is a plus.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Material Design optimization is a plus.
                      </li>
                    </ul>
                  </Box>
                </Grid>

                {/* What We Offer Section - Full Width */}
                <Grid item xs={12}>
                  <Box>
                    <Box align="left">
                      <Typography variant="h4">What We Offer</Typography>
                    </Box>
                    <ul style={{ marginTop: -2 }}>
                      <li style={styles.DescriptionTxt}>
                        MacBook Pro & Monitor for best dev setup.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Upto 5k book/course reimbursement.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Monthly internet reimbursement.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Fun Fridays every alternate weekend.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Ongoing growth & dev courses.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Paid time off & parental leave.
                      </li>
                      <li style={styles.DescriptionTxt}>
                        Flexible working environment.
                      </li>
                    </ul>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            {/* form box  */}
            <Box
              sx={{
                // backgroundColor: "#f5f6fa",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                p: { xs: 3, md: 0 },
              }}
            >
              <Paper
                elevation={1}
                sx={{
                  maxWidth: 550,
                  width: "100%",
                  borderRadius: 3,
                  px: { xs: 3, sm: 6 },
                  py: { xs: 4, sm: 3 },
                }}
              >
                <Typography
                  variant="h5"
                  fontWeight={600}
                  align="center"
                  gutterBottom
                  sx={{ fontFamily: '"Poppins", serif' }}
                >
                  Apply Now
                </Typography>

                <Typography
                  variant="body1"
                  color="textSecondary"
                  align="center"
                  mb={2}
                  sx={{ fontFamily: '"Poppins", serif' }}
                >
                  Fill in the details below and we will get in touch with you as
                  soon as possible.
                </Typography>

                <Grid container spacing={2}>
                  {/* Personal Information Section */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Full Name *"
                      placeholder="John Doe"
                      variant="outlined"
                      sx={{
                        ...styles.InputStyling,
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: "100%",
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                          width: "100%",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      sx={{
                        // ...styles.InputStyling,
                        // width: "100%",
                        width: "207px",
                        minWidth: "100%",
                      }}
                    >
                      <InputLabel
                        sx={{
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                          width: "100%",
                        }}
                      >
                        Gender *
                      </InputLabel>
                      <Select
                        label="Gender *"
                        variant="outlined"
                        sx={{
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                          width: "100%",
                          maxWidth: "100%",
                          minWidth: "100%",
                          height: "56px", // Match other input heights
                        }}
                      >
                        <MenuItem
                          value="male"
                          sx={{
                            fontFamily: '"Poppins", serif',
                            fontSize: "0.9rem",
                            width: "100%",
                            maxWidth: "100%",
                          }}
                        >
                          Male
                        </MenuItem>
                        <MenuItem
                          value="female"
                          sx={{
                            fontFamily: '"Poppins", serif',
                            fontSize: "0.9rem",
                            width: "100%",
                            maxWidth: "100%",
                          }}
                        >
                          Female
                        </MenuItem>
                        <MenuItem
                          value="other"
                          sx={{
                            fontFamily: '"Poppins", serif',
                            fontSize: "0.9rem",
                            width: "100%",
                            maxWidth: "100%",
                          }}
                        >
                          Other
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Email Address *"
                      placeholder="example@example.com"
                      variant="outlined"
                      sx={{
                        ...styles.InputStyling,
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: "100%",
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                          width: "100%",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Mobile Number *"
                      placeholder="+91 99XX XXX XXX"
                      variant="outlined"
                      sx={{
                        ...styles.InputStyling,
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: "100%",
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                          width: "100%",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                        },
                      }}
                    />
                  </Grid>

                  {/* Professional Information Section */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Highest Education *"
                      placeholder="e.g., B.Tech, MBA, etc."
                      variant="outlined"
                      sx={{
                        ...styles.InputStyling,
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: "100%",
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                          width: "100%",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Total Experience *"
                      placeholder="e.g., 3 years"
                      variant="outlined"
                      sx={{
                        ...styles.InputStyling,
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: "100%",
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                          width: "100%",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Current CTC *"
                      placeholder="e.g., 8 LPA"
                      variant="outlined"
                      sx={{
                        ...styles.InputStyling,
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: "100%",
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                          width: "100%",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Expected CTC *"
                      placeholder="e.g., 12 LPA"
                      variant="outlined"
                      sx={{
                        ...styles.InputStyling,
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: "100%",
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                          width: "100%",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Notice Period *"
                      placeholder="e.g., 30 days"
                      variant="outlined"
                      sx={{
                        ...styles.InputStyling,
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: "100%",
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                          width: "100%",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Reason for Change"
                      placeholder="Why are you looking for a change?"
                      variant="outlined"
                      sx={{
                        ...styles.InputStyling,
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: "100%",
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                          width: "100%",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Current Address *"
                      placeholder="Your complete address"
                      multiline
                      rows={3}
                      variant="outlined"
                      sx={{
                        ...styles.InputStyling,
                        "& .MuiOutlinedInput-root": {
                          height: "auto", // Allow multiline to expand
                          minHeight: "56px", // Minimum height to match other fields
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontFamily: '"Poppins", serif',
                          fontSize: "0.9rem",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <InputLabel shrink sx={styles.DescriptionTxt}>
                      Upload Resume *
                    </InputLabel>
                    <input type="file" accept=".doc,.docx,.rtf,.pdf" />
                    <FormHelperText sx={styles.SupportedLabelTxt}>
                      Supported Formats: doc, docx, rtf, pdf, upto 2 MB
                    </FormHelperText>
                  </Grid>
                </Grid>

                <Grid item xs={12} textAlign="left" mt={2}>
                  <Button
                    size="large"
                    variant="contained"
                    onClick={() => {}}
                    sx={styles.SubmitButtonStyling}
                  >
                    Submit
                  </Button>
                </Grid>
              </Paper>
            </Box>
          </Container>
        </Box>

        <Container maxWidth="lg">
          <Box sx={{ px: 0, py: 4 }}>
            <Box align="left" ml={-1}>
              {/* <Heading title="About The Company" /> */}
              <Typography variant="h4">About The Company</Typography>
            </Box>

            <Box>
              <Typography
                sx={{
                  fontFamily: '"Poppins", serif',
                  fontSize: { xs: "0.85rem", sm: "0.85rem", md: "0.9rem" },
                  textAlign: "justify",
                }}
              >
                Across Assist is a technology-driven B2B Consumer Benefits
                Marketplace catering to both National and International Markets.
                Founded in the year 2011 with headquarters in India (Across
                Assist Pvt. Ltd.). Across Assist provides an ecosystem that
                delivers premium customer acquisition, retention, and allegiance
                services to the world’s leading financial institutions & card
                networks. We run India’s largest tech-enabled Golf management
                platform and now, have evolved ourselves to offer a host of
                lifestyle, wellness, entertainment and shopping benefits. With
                over 1,00,000+ partner associations and service delivery
                presence in 130 countries worldwide, we empower clients to
                invigorate engagement with their most valuable customers. As a
                software engineer, you will help to build awesome
                benefit/loyalty solutions for our customers. You’ll work
                alongside smart, successful, and kind people who are passionate
                about start-ups.
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default JobDetails;

const styles = {
  DescriptionTxt: { fontFamily: '"Poppins", serif', fontSize: "0.9rem" },
  ParentContainer: {
    // px: { xs: 2, md: 6 },
    px: { xs: 2, md: 0 },
    py: { xs: 2, md: 3 },
    backgroundColor: "#f9f4f2",
    display: { xs: "block", md: "flex" },
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "nowrap",
  },
  DetailsContainer: { flex: 1, pr: { md: 4 } },
  InputStyling: {
    // maxWidth: '20rem',
    width: "100%",
    fontFamily: '"Poppins", serif',
    fontSize: "0.9rem",
    "& .MuiOutlinedInput-root": {
      width: "100%",
      height: "56px", // Standard Material-UI input height
    },
    "& .MuiInputLabel-root": {
      width: "100%",
      fontFamily: '"Poppins", serif',
      fontSize: "0.9rem",
    },
    "& .MuiInputBase-input": {
      width: "100%",
      fontFamily: '"Poppins", serif',
      fontSize: "0.9rem",
    },
  },
  SubmitButtonStyling: {
    color: "white",
    fontWeight: 600,
    fontSize: "13px",
    borderRadius: "4px",
    textTransform: "none",
    fontFamily: '"Poppins", serif',
    padding: "8px 45px",
    // padding: "8px 15px",
    transition: "all 0.3s ease-in-out",
    background: "linear-gradient(93.14deg, #1E90FF, #63B8FF)",
    "&:hover": {
      background: "linear-gradient(93.14deg, #63B8FF, #1E90FF)",
      color: "#fff",
    },
    "@media (max-width: 600px)": { fontSize: "13px", width: "295px" },
  },
  SupportedLabelTxt: {
    fontFamily: '"Poppins", serif',
    fontSize: "0.7rem",
  },
};
